module.exports = __webpack_public_path__ + "media/checkout/cart-284fbf21.png";